/**
 * Gruppi Omogenei — coreBOS `PersonalDataCategories` (70x) on evo-gdpr.evolutivo.it.
 * Harvested from evo-mcp-limitless@origin/evo-policies by scripts/harvest/gen_descriptors.py.
 * Frameworks: dlgs81. Type sources per field: docs/harvest-report.md.
 * Regenerate instead of hand-editing; hand edits belong in the generator's SPEC.
 */
export const workerGroupDescriptor = {
    slug: 'cmp_worker_group',
    kind: 'document',
    label: { singular: 'Gruppo omogeneo / Classe incarico', plural: 'Gruppi Omogenei / Classi Incarico' },
    table: 'compliance_worker_group',
    idStrategy: 'sha256',
    fields: [
        { name: 'data_category_name', type: 'text', label: 'Nome Gruppo', required: true },
        { name: 'framework_tags', type: 'text', label: 'Framework' },
        { name: 'activity_type', type: 'text', label: 'Tipo Attività' },
        { name: 'n_workers', type: 'text', label: 'N. Lavoratori' },
        { name: 'mansioni', type: 'text', label: 'Mansioni' },
        { name: 'luoghi_lavoro', type: 'text', label: 'Luoghi di Lavoro' },
        { name: 'orario_lavoro', type: 'text', label: 'Orario' },
        { name: 'dpi_required', type: 'text', label: 'DPI Richiesti' },
        { name: 'sorveglianza_sanitaria', type: 'boolean', label: 'Sorv. Sanitaria' },
        { name: 'frequenza_visita', type: 'text', label: 'Frequenza Visita' },
        { name: 'next_visit_group', type: 'date', label: 'Prossima Visita' },
        { name: 'multi_complexity', type: 'text', label: 'Multi complexity' },
        { name: 'istemplate', type: 'boolean', label: 'Template' },
        { name: 'description', type: 'text', label: 'Note' },
        { name: 'personaldatacategories_no', type: 'text', label: 'Codice' },
    ],
    relations: [
        { name: 'relpdc_account', kind: 'belongsTo', target: 'account', toEntitySpine: true },
        { name: 'dvr_link', kind: 'belongsTo', target: 'cmp_audit' },
        { name: 'assigned_user', kind: 'belongsTo', target: 'user', toEntitySpine: true },
    ],
    behaviors: { ownership: true, audit: true, softDelete: true, tenantScoped: true },
    ui: { mode: 'generated', icon: 'TeamOutlined', navGroup: 'Sicurezza Lavoro', deadlines: [{ field: 'next_visit_group' }] },
};
